import React from 'react';
import Avatar from '@material-ui/core/Avatar'
import Button from '@material-ui/core/Button';
import moment from 'moment'


const NotificationItem = ({notification}) => {
    const {wpTime, msg, description, description_type, licensePlate, street} = notification;
    const icon = 'zmdi-calendar-note mdc-text-blue'
    const icon2 = 'zmdi-truck'
    return (
        <li className="media">
            {/*<Avatar
                alt='https://via.placeholder.com/150x150'
                src='https://via.placeholder.com/150x150'
                className=" mr-2"
            />*/}
            <i className={`zmdi ${icon2} zmdi-hc-fw zmdi-hc-2x`}/>
            <div className="media-body align-self-center">
                <p className="sub-heading mb-0">{
                    `[${licensePlate}] is ${description} at ${street}`
                }</p>
                <Button size="small" className="jr-btn jr-btn-xs mb-0"><i
                    className={`zmdi ${icon} zmdi-hc-fw`}/></Button> <span className="meta-date"><small>{wpTime}</small></span>
            </div>
        </li>
    );
};

export default NotificationItem;



// WEBPACK FOOTER //
// ./components/AppNotification/NotificationItem.js